import PropTypes from 'prop-types'
import {JsonViewer} from '../../../../../../../common/JsonViewer.jsx'
import {HeaderTitle} from '../../../../../../../common/HeaderTitle.jsx'
import RadioWiz from "../../../../../../../common/inputs/wizard/RadioWiz.jsx";
import {optionsTakNie} from "../../../../../../../utils/options.js";

export const OchronaDanych = (props) => {
    const wiz = props.wiz
    const form = wiz?.form || {}

    const isPrzetwarzanie = form.czy_przetwarzanie_danych === 'Tak'

    return (
        <div>
            <JsonViewer src={wiz?.form || {}} show={false}/>

            <HeaderTitle noHr size={'fs-3'} title={'Ochrona danych'}/>
            <HeaderTitle
                noHr
                size={'fs-4'}
                title={'Wprowadź informację na temat ochrony danych'}
            />

            <div className={'d-flex flex-column gap-3'}>
                <RadioWiz
                    wiz={wiz}
                    keyName={'czy_przetwarzanie_danych'}
                    label={wiz?.getLabel('czy_przetwarzanie_danych')}
                    options={optionsTakNie}
                />
                {isPrzetwarzanie && (
                    <RadioWiz
                        wiz={wiz}
                        keyName={'czy_inspektor_ochrony_danych'}
                        label={wiz?.getLabel('czy_inspektor_ochrony_danych')}
                        options={optionsTakNie}
                    />
                )}
            </div>
        </div>
    )
}

OchronaDanych.propTypes = {
    wiz: PropTypes.any,
}